<h1 mat-dialog-header>
  @if (currentStep === 0) {
    Select a Case to Copy
  } @else if (currentStep === 1) {
    Choose Information to Copy
  }
</h1>
<div #scroll mat-dialog-content class="copy-case dialog-container">
  @if (currentStep === 0) {
    <div>
      <ng-container #gridContainer />
    </div>
  } @else if (currentStep === 1) {
    <div class="checkbox-sections row">
      @for (header of headerItems; track header; let i = $index) {
        <section class="example-section">
          <div class="example-list-section">
            <div class="example-header">
              <mat-checkbox
                class="example-margin"
                [checked]="header.checked"
                [indeterminate]="partiallyCompleteHeader(i)"
                (change)="update($event.checked, i)"
              >
                {{ header.display }}
              </mat-checkbox>
            </div>
            <ul>
              @for (main of header.mainItems; track main; let j = $index) {
                <li>
                  <mat-checkbox
                    [checked]="main.checked"
                    [indeterminate]="partiallyCompleteMain(i, j)"
                    (change)="update($event.checked, i, j)"
                  >
                    {{ main.display }}
                  </mat-checkbox>
                  <ul>
                    @for (item of main.subItems; track item; let k = $index) {
                      <li>
                        <mat-checkbox
                          [checked]="item.checked"
                          (change)="update($event.checked, i, j, k)"
                        >
                          {{ item.display }}
                        </mat-checkbox>
                      </li>
                    }
                  </ul>
                </li>
              }
            </ul>
          </div>
        </section>
      }
    </div>
  }
</div>
<div mat-dialog-actions class="buttons">
  <div>
    <button type="button" mat-raised-button (click)="cancel()"> Cancel </button>
  </div>
  @if (currentStep === 1) {
    <div class="copy-warning-container mx-2">
      <span class="copy-warning">
        You’re about to copy information from another case.<br />
        To ensure all data is accurate, you’ll be returned to the start of the
        questionnaire.
      </span>
    </div>
  }
  <div>
    @if (this.currentStep !== 0 && !hideBack) {
      <button type="button" mat-raised-button (click)="back()">Back</button>
    }
    <button
      type="button"
      mat-raised-button
      color="accent"
      [disabled]="
        !currentSelectedProfileID ||
        (currentStep === 1 && parseCheckedItems().groups.length <= 0)
      "
      (click)="next()"
    >
      @if (currentStep === 1) {
        Submit
      } @else {
        Next
      }
    </button>
  </div>
</div>
